import type { ColoredMaterialSpecification } from "@color-finder/color-finder-api/models";

export function formatGloss(
  gloss: "Included" | "Excluded" | string | undefined,
): string | undefined {
  const glossMapping: Record<"Included" | "Excluded", string> = {
    Included: "SPIN",
    Excluded: "SPEX",
  };
  return gloss ? glossMapping[gloss as "Included" | "Excluded"] : undefined;
}

export function formatMeasurementCondition(spec: ColoredMaterialSpecification) {
  return [spec.observer, spec.measurementMode, formatGloss(spec.gloss)]
    .filter((v) => v)
    .join(" | ");
}
